import { api } from "@/lib/api/client";
import type {
  PulseActivityResponse,
  PulseInboxResponse,
  PulseTrafficResponse,
} from "./types";

export async function fetchPulseInbox(): Promise<PulseInboxResponse> {
  const { data } = await api.get<PulseInboxResponse>("/api/nexus/pulse/inbox");
  return data;
}

export async function fetchPulseTraffic(): Promise<PulseTrafficResponse> {
  const { data } = await api.get<PulseTrafficResponse>("/api/nexus/pulse/traffic");
  return data;
}

export async function fetchPulseActivity(limit = 20): Promise<PulseActivityResponse> {
  const { data } = await api.get<PulseActivityResponse>("/api/nexus/pulse/activity", {
    params: { limit },
  });
  return data;
}
